export const postcodePattern = /^(GIR 0AA|[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2})$/i;
export const addressLinePattern = /^(?=.*\S)[A-Za-z0-9\s,.\-#!@£$%^&*()'_+=[\]\\/;:<>?|]+$/;